// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2POJL","errors":"Errors_errors__23cIJ"};